import { createApp } from 'vue';
import store from './store/store'; // Assuming store is Vuex 4 compatible
import PrintMaps from './PrintMaps.vue';
import mapboxgl from 'mapbox-gl';
import { i18n } from '../../i18n';

console.log('print_maps/main.ts - Vue 3');

// Set the Mapbox access token globally (can also be done within the component)
// It's often better to keep sensitive tokens like this in environment variables
mapboxgl.accessToken = "pk.eyJ1IjoiaGlpa2VyLW1hcHMiLCJhIjoiY2x0YThyZHppMWhmejJqbzExODBuY3dveiJ9.nBrtnXgbzxpAx_953HCB-w";

// Find the mount point
const mountPoint = document.querySelector('#print_maps');

if (mountPoint) {
  const app = createApp(PrintMaps);

  // Use the Vuex store
  app.use(store);

  // Mount the application
  app.use(i18n);
  app.mount('#print_maps');

} else {
  console.error("Mount point #print_maps not found.");
}

// Note: The logic previously in beforeCreate and mounted (store initialization, etc.)
// has been moved into the PrintMaps.vue component's setup/onMounted hook,
// as it's more closely related to the component's lifecycle and the map itself.
